import {appendPaginationQueryParamsToUrl, get} from '../utils'

const url = (host, options, withoutIncludes) => appendPaginationQueryParamsToUrl(`${host}/playlists?include=translations${withoutIncludes ? ``: `;client;channel.domain`}&order_by=created_at&sort_type=DESC`, {...options, alreadyHasQueryParams: true})

export default host => (options, withoutIncludes = false) =>
  get(url(host, options, withoutIncludes))
    .then(response => response.json())
    .then(json => json.meta ? json : json.data)